import Loader from "modules/Loader";
import React, { useEffect, useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { Bar } from "react-chartjs-2";
import DatePicker from "react-datepicker";
import { usePyamentsHourlyDashboard } from "./store";
import moment from "moment";

const FailedTransactions = () => {
  const { fetchPaymentsHourlyDashboard, pyamentsDashboardData, isLoading } =
  usePyamentsHourlyDashboard();
  const date = new Date();
  const [startDate, setStartDate] = useState(date.setDate(date.getDate() - 7));
  const [endDate, setEndDate] = useState(new Date());
  const [selectedGateway, setSelectedGateway] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedType, setSelectedType] = useState("daily"); // Add state for type

  useEffect(() => {
    if (startDate && endDate) {
      const startOfDate = moment(startDate).startOf("D").toISOString();
      const endOfDate = moment(endDate).endOf("D").toISOString();
      const payload = {
        startDate: startOfDate,
        endDate: endOfDate,
        paymentGateway: "",
        status: "",
        type: selectedType, // Used selectedType in the payload
      };
      fetchPaymentsHourlyDashboard(payload);
    }
  }, [selectedType]); // Included selectedType in dependencies
  const handleClear = () => {
    setEndDate(new Date());
    setStartDate(new Date().setDate(new Date().getDate() - 7));
    setSelectedGateway("");
    setSelectedStatus("");
  };

  const handleSubmit = () => {
    const startOfDate = moment(startDate).startOf("D").toISOString();
    const endOfDate = moment(endDate).endOf("D").toISOString();
    const payload = {
      startDate: startOfDate,
      endDate: endOfDate,
      paymentGateway: selectedGateway,
      status: selectedStatus,
      type: selectedType,
    };
    fetchPaymentsDashboard(payload);
  };

  const handleTypeToggle = () => {
    // Toggle between "daily" and "hourly" types
    const newType = selectedType === "daily" ? "hourly" : "daily";
    setSelectedType(newType);
  };

  const maxSelectableDate = moment(startDate).add(14, "days").toDate();
  const transactionData = {
    failureRateByGateway: pyamentsDashboardData.failureRateByGateway,
  };
  
  function convertToChartData(transactionData) {
    const chartData = {
      labels: [],
      datasets: [
        {
          label: "PayU",
          type: 'line',
          data: [],
          backgroundColor: "rgba(3,122,252, 0.6)",
        },
        {
          label: "Razorpay",
          type: 'line',
          data: [],
          backgroundColor: "rgba(220,63,69, 0.6)",
        },
        // if we add more payment gatways this needs to be updated
      ],
    };

    // Iterate through the transaction data and update the chart data
    for (const date in transactionData.failureRateByGateway) {
      const payUTransactions =
        transactionData.failureRateByGateway[date].payu || 0;
      const razorpayTransactions =
        transactionData.failureRateByGateway[date].razorpay || 0;
      // if we add more payment gatways this needs to be updated
      const index = chartData.labels.indexOf(date);
      if (index !== -1) {
        chartData.datasets[0].data[index] = payUTransactions;
        chartData.datasets[1].data[index] = razorpayTransactions;
      } else {
        chartData.labels.push(date);
        chartData.datasets[0].data.push(payUTransactions);
        chartData.datasets[1].data.push(razorpayTransactions);
      }
    }

    return chartData;
  }
  const chartData = convertToChartData(transactionData);
  function addSumToLabel(data) {
    // Iterate through datasets
    data.datasets.forEach((dataset) => {
      const sum = dataset.data.reduce((acc, value) => acc + value, 0);
      const formattedSum = sum.toFixed(2);
      dataset.label = `${dataset.label} (Sum: ${formattedSum})`;
    });

    return data;
  }

  const labeledData = addSumToLabel(chartData);
  return (
    <div style={{ width: "100rem" }}>
      <div
        className="d-flex gap-2"
        style={{ width: "70rem", alignItems: "center" }}
      >
        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          formatWeekDay={(day) => day.slice(0, 3)}
          className="form-control"
          placeholderText="Select Date"
        />
        <DatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          formatWeekDay={(day) => day.slice(0, 3)}
          className="form-control"
          placeholderText="Select Date"
          minDate={startDate}
          maxDate={maxSelectableDate}
        />
        <Dropdown>
          <Dropdown.Toggle variant="primary">
            {selectedGateway
              ? `Filter: ${selectedGateway}`
              : "Filter By Gateway"}
          </Dropdown.Toggle>
          <Dropdown.Menu className="py-2">
            <Dropdown.Item onClick={() => setSelectedGateway("payu")}>
              PayU
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setSelectedGateway("razorpay")}>
              Razorpay
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown>
          <Dropdown.Toggle variant="primary">
            {selectedStatus
              ? `Filter: ${selectedStatus === "failed" ? "Failed" : "Success"}`
              : "Filter By Status"}
          </Dropdown.Toggle>
          <Dropdown.Menu className="py-2">
            <Dropdown.Item onClick={() => setSelectedStatus("failed")}>
              Failed
            </Dropdown.Item>
            <Dropdown.Item onClick={() => setSelectedStatus("success")}>
              Success
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <button className="btn btn-primary" onClick={handleSubmit}>
          Submit
        </button>
        <button className="btn btn-primary" onClick={handleClear}>
          Clear
        </button>
        <Form.Check
          type="switch"
          id="defaultSwitch"
          label="Hourly"
          checked={selectedType === "hourly"}
          onChange={handleTypeToggle}
        />
      </div>
      {isLoading ? (
        <div className="position-absolute mt-5 start-50 translate-middle">
          <Loader />{" "}
        </div>
      ) : (
        <Bar data={labeledData} />
      )}
    </div>
  );
};

export default FailedTransactions;
